import axios from 'axios';
import { Message } from 'element-ui';
import {
    Base64
} from 'js-base64';
import {
    getToken,
    removeToken
} from '@/utils/auth';
import { logout } from "../api/user";
// console.log('location. hostname', location.hostname);
const instance = axios.create({
    timeout: 60000
});
instance.defaults.withCredentials = true;
instance.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
        if (getToken()) {
            if (config.url === '/api/experiment/comfort/upload' || config.url === '/api/experiment/analysis/upload') {
                config.timeout = 600000;
            }
            config.headers['Blade-Auth'] = 'Bearer ' + getToken();
            config.headers['Authorization'] = `Basic ${Base64.encode(`${'saber'}:${'saber_secret'}`)}`;
        } else {
            backToLogin();
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// response interceptor
instance.interceptors.response.use(
    response => {
        const res = response.data;

        if (res.code) {
            if (res.code === 200) {
                return res;
            } else if (res.code === 400) {
                Message({
                    message: res.msg || '服务繁忙，稍候重试',
                    type: 'warning',
                    duration: 5 * 1000
                });
                return res;
            }
            else if (res.code === 300) {
                Message({
                    message: res.msg || '服务繁忙，稍候重试',
                    type: 'warning',
                    duration: 5 * 1000
                });
                return res;
            } else if (res.code === 401) {
                backToLogin();
            } else {
                Message({
                    message: res.msg || '服务繁忙，稍候重试',
                    type: 'error',
                    duration: 5 * 1000
                });
            }
        } else {
            if (response.headers['content-disposition']) {
                return response;
            } else {
                return res;
            }
        }
        return Promise.reject(res.msg || '服务繁忙，稍候重试');
    },
    (error) => {
        Message({
            message: error.response.data.msg,
            type: 'error',
            duration: 5 * 1000
        });
        return error.response;
    }
);

function backToLogin() {
    removeToken();
    window.location.href = 'http://' + process.env.JUMPURL + '/#/login';
}

export default instance;



// WEBPACK FOOTER //
// ./src/utils/request.js